import { Controller } from 'stimulus';

/**
 *  Show shipping VatController form
 *
 * @class VatController
 * @extends {Controller}
 */
class VatController extends Controller {
  connect() {
    this.toggleVatField();
  }

  onCountryChange() {
    this.toggleVatField();
  }

  toggleVatField() {
    if (!this.hasVatTarget) return;

    const isBelgium = this.countryTarget.value === '2';

    $(this.vatTarget).toggle(isBelgium);
  }
}

VatController.targets = [
  'vat',
  'country',
];

export default VatController;
